import toDollars from 'utils/to-dollars';

interface Props {
    input: {
        value: any;
    };
}

const RenderValue = ({ input: { value } }: Props): any => toDollars(value);

export default RenderValue;
